<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 m-0 headingFontsize">Locked Users</div>
        <div class="p-0 m-0">
          <bread-crumb :bread-crumbs="['Locked Users']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0"></v-divider>
      <v-card-text>
        <v-form v-model="valid" ref="user">
          <v-row class="mt-1">
            <!-- <v-col col="12" md="2">
              <v-text-field
                v-model="username"
                hide-details
                dense
                outlined
                label="User Name"
              ></v-text-field
            ></v-col>
            <v-btn
              depressed
              color="primary"
              @click="getLockedusers()"
              small
              class="text-capitalize"
            >
              Get Results
            </v-btn> -->

            <v-spacer></v-spacer>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Type here to filter the table data."
                single-line
                hide-details
                class="me-4"
                dense
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-data-table
          fixed-header
          height="55vh"
          :headers="headers"
          :items="userlocked"
          sort-by="calories"
          dense
          class="mt-4 p-1"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" color="primary" @click="editItem(item)">
              mdi-lock
            </v-icon>
          </template>
        </v-data-table>
        <OverlayPageVue :showOverlay="loaderOverlay" />
      </v-card-text>

      <v-dialog persistent v-model="dialog" max-width="700px">
        <v-card>
          <v-card-title>
            <v-row>
              Unlock Users
              <v-spacer></v-spacer>
              <v-btn depressed icon>
                <v-icon @click="dialog = false"> mdi-close </v-icon></v-btn
              >
            </v-row>
          </v-card-title>
          <v-divider class="mt-0"></v-divider>
          <v-card-text class="mt-3">
            <v-form v-model="valid" ref="unlock">
              <v-row
                ><label class="my-0 labelFontsize"> Full Name</label></v-row
              >
              <v-row>
                <v-text-field
                  placeholder=" Full Name"
                  class="rounded"
                  required
                  outlined
                  dense
                  :disabled="true"
                  v-model="lockedCustomers.full_name"
                >
                </v-text-field>
              </v-row>
              <v-row><label class="my-0 labelFontsize">Remarks</label></v-row>
              <v-row>
                <v-textarea
                  outlined
                  class="rounded"
                  :rules="[(v) => !!v || 'Required']"
                  placeholder="Please provide the reason"
                  v-model="lockedCustomers.remarks"
                ></v-textarea
              ></v-row>
            </v-form>
          </v-card-text>
          <v-divider class="pa-0 ma-0"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              dense
              small
              depressed
              title="Unlock Customer"
              class="text-capitalize ms-10"
              color="primary"
              @click="updateLockedCustomers()"
            >
              <v-icon small left> mdi-lock-open-variant </v-icon>Unlock Customer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </section>
</template>
<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import userService from "@/services/UserService/userService.js";
import alerts from "@/mixins/alerts";
export default {
  name: "Locked Users",
  mixins: [alerts],
  data: () => ({
    dialog: false,
    search: "",
    loaderOverlay: false,
    userlocked: [],
    lockedCustomers: {
      full_name: "",
      user_id: null,
      lock_status: null,
      remarks: "",
    },
    headers: [
      {
        text: "User ID",
        sortable: false,
        value: "user_id",
      },
      {
        text: "Full Name",
        sortable: false,
        value: "full_name",
      },
      { text: "Email", value: "email_id" },
      { text: "Last Login Date", value: "last_login_date" },
      { text: "Locked Date", value: "locked_date" },
      { text: "IP Address", value: "ip_address" },
      // { text: "Agent/Branch", value: "" },
      { text: "Status", value: "user_status" },
      { text: "Reason", value: "locked_reason" },
      { text: "UnLock", value: "actions", sortable: false },
    ],
  }),

  components: {
    BreadCrumb,
    OverlayPageVue,
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  // created () {
  // this.initialize()
  // },
  mounted() {
    this.getLockedUsers();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },

    async getLockedUsers() {
      this.loaderOverlay = true;
      try {
        const params = {
          skip: 0,
          limit: 50,
        };
        const response = await userService.getLockedUsers(params);
        if (response.status === 200) {
          this.userlocked = response.data.data;
          console.log("customerLocked", this.userlocked);
          this.stoploader();
        } else {
          this.userlocked == [];
          this.stoploader();
        }
      } catch (error) {
        this.userlocked = [];
        this.stoploader();
        console.error(error);
      }
    },
    async updateLockedCustomers() {
      if (this.$refs.unlock.validate()) {
        try {
          const responseData = await userService.updateLockedCustms(
            this.lockedCustomers.user_id,
            false,
            this.lockedCustomers.remarks,
            this.lockedCustomers
          );
          if (responseData.data.status_code == 200) {
            console.log("response", responseData);
            this.dialog = false;
            this.showAlertSuccess("Customer status updated successfully");
            this.getLockedUsers();
          } else {
            this.showAlertError("Failed: " + responseData.data.message);
          }
        } catch (error) {
          this.showAlertError("Failed: Something went wrong");
          console.log(error.response);
        }
      }
    },
    editItem(item) {
      this.loaderOverlay = false;
      this.lockedCustomers.full_name = item.full_name;
      this.lockedCustomers.user_id = item.user_id;
      this.lockedCustomers.remarks = item.remarks;
      console.log(item);
      this.dialog = true;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
